import DeviceManufacturersList from './DeviceManufacturersList';

export default DeviceManufacturersList;
